// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"hp-z","slideIn":"ip-z"};